import { createAsyncThunk, createSlice, AsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { RootState } from "../store";
import businessService from "../../API/businessApi";

interface Business {
    id: string,
    businessMerchantId: string;
    businessName: string;
    category: string,
    pricing: number,
    openingHours: string,
    services: string,
    status: string,
}



interface AsyncThunkConfig {
  state: RootState;
  rejectValue: string; 
}

//@ts-ignore
export const asyncRetrieveBusinesses: AsyncThunk<Business[], void, AsyncThunkConfig> = createAsyncThunk(
  "business/retrieve",
  async (_, thunkApi) => {
    try {
      const res = await businessService.retrieveBusiness();
      return res.data.data;
    } catch (error: any) {
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      toast.error(errorMessage);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);



const businessSlice = createSlice({
  name: "business",
  initialState: {
    data: [] as Business[],
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(asyncRetrieveBusinesses.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(asyncRetrieveBusinesses.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(asyncRetrieveBusinesses.rejected, (state) => {
        state.isLoading = false;
      })
  },
});

export const allBusinesses = (state: RootState) => state.business;
export default businessSlice.reducer;
